"use client";
export const WelcomeSection = () => {
  return (
    <div className="w-full">
      <h1 className="text-xl font-bold text-white leading-tight">
        Fearless
      </h1>
      <p className="text-l font-light text-white mt-1">
        Boundless. Unstoppable
      </p>
    </div>
  );
};
